import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import ROUTES from '@src/constants/route';
import { InfoRounded } from '@mui/icons-material';
import AdsBackground from '@src/assets/banners/ads.png';
import { CRM_URL } from '@src/configs';
import AdsBackground1 from '@src/assets/banners/ads-01.svg';
import { getPackagesName } from '@src/services/package';
import { useCheckDubbingRoute } from '@src/hooks/useCheckDubbingRoute';
import {
  StyledAdsItem,
  StyledSidebarTooltip,
  StyledVoucherBanner,
} from './index.style';
import CountdownBanner from './CountdownBanner';

export const VOUCHER_BANNER_TEMPLATE = {
  STANDARD: 'voucher',
  FIRST_PAID_VOUCHER: 'firstPaidVoucher',
};

const bannerStyles = {
  [VOUCHER_BANNER_TEMPLATE.STANDARD]: {
    backgroundImg: AdsBackground,
    showCountdown: true,
  },
  [VOUCHER_BANNER_TEMPLATE.FIRST_PAID_VOUCHER]: {
    backgroundImg: AdsBackground1,
    showCountdown: false,
  },
};

const VoucherBanner = ({
  voucher = {},
  template = VOUCHER_BANNER_TEMPLATE.STANDARD,
}) => {
  const { i18n } = useTranslation();
  const { t, language } = i18n;
  const history = useHistory();
  const isDubbingRoute = useCheckDubbingRoute();
  const { policy = {} } = voucher;
  const { applyAllPackages, packages = [] } = policy;

  const { backgroundImg, showCountdown } = bannerStyles[template];

  const handleRedirectPayment = (e, link) => {
    e?.target?.blur();
    if (link) {
      if (link.startsWith(CRM_URL)) {
        window.location.href = link;
        return true;
      }
      window.open(link, '_blank', 'noopener');
      return true;
    }
    return isDubbingRoute
      ? history.push(ROUTES.PAYMENT_DUBBING)
      : history.push(ROUTES.PAYMENT);
  };

  const TooltipTitle = () => (
    <Box display="flex" justifyContent="center" paddingX="-2px">
      <Typography
        className="tooltip-title"
        dangerouslySetInnerHTML={{
          __html: t('applyVoucherWithPackages', {
            packageNames: getPackagesName(packages, language, t),
          }),
        }}
        fontSize="14px"
        lineHeight="20px"
        letterSpacing="-0.4px"
        fontWeight="400"
      />
    </Box>
  );

  const renderTitle = () => {
    const voucherContent = voucher?.isBannerSidebar ? (
      <Typography style={{ color: voucher.color }} className="title">
        {voucher.content?.[language]}
      </Typography>
    ) : (
      <Typography className="title">{voucher.title?.[language]}</Typography>
    );

    return (
      <Box className="title-wrapper">
        {!applyAllPackages && !voucher.isBannerSidebar && (
          <div className="tooltip-wrapper">
            <StyledSidebarTooltip title={<TooltipTitle />}>
              <InfoRounded color="white" className="icon" fontSize="16px" />
            </StyledSidebarTooltip>
          </div>
        )}
        {voucherContent}
      </Box>
    );
  };

  const renderActionButton = () => {
    if (voucher?.isBannerSidebar) {
      return voucher?.buttonText ? (
        <div className="button-wrapper">
          <Button className="button">{voucher?.buttonText}</Button>
        </div>
      ) : null;
    }

    if (showCountdown)
      return (
        <div className="button-wrapper">
          <Button className="button">
            {t('still')}
            <CountdownBanner
              date={
                voucher.fakeEndTimeForVoucher
                  ? new Date(voucher.fakeEndTimeForVoucher).getTime() + 100
                  : new Date(voucher?.endTime).getTime() + 100
              }
            />
            {`- ${t('renewNow')}`}
          </Button>
        </div>
      );
    return (
      <div className="button-wrapper">
        <Button className="button button-highlight">{t('buyNow')}</Button>
      </div>
    );
  };

  return (
    <StyledAdsItem onClick={(e) => handleRedirectPayment(e, voucher?.link)}>
      <StyledVoucherBanner
        voucherImg={backgroundImg}
        applyAllPackages={applyAllPackages}
      >
        {renderTitle()}
        {renderActionButton()}
      </StyledVoucherBanner>
    </StyledAdsItem>
  );
};

export default VoucherBanner;
